import React from "react"
import Generator from "../library-js/utils/Generator";

export default ({Svg, G, Path, Circle, Defs, LinearGradient, Rect, Stop}) => ({

	// ---- chat ---
	/**
	 * @deprecated [user] use chat instead
	 */
	shopChat: (...color) => {
		const DEFAULT_COLORS = ['#6c63ff', 'white'];
		color = DEFAULT_COLORS.map((defaultColor, index) => color[index] || defaultColor);

		return (
			<Svg viewBox="0 0 258.997 198.748">
				<G transform="translate(-255 -416)">
					<Path
						fill={color.first}
						stroke={color.last}
						strokeWidth={5}
						transform="matrix(1, 0, 0, 1, 255, 416) translate(9 6)"
						d="M93.85,0H154.1A86.9,86.9,0,0,1,241,86.9a93.85,93.85,0,0,1-93.85,93.85H0V93.85A93.85,93.85,0,0,1,93.85,0Z"/>

					<G
						fill={color.last}
						transform="translate(324.249 496.153)">

						<Circle cx="14" cy="14" r="14" transform="translate(0.249 -0.279)"/>
						<Circle cx="14" cy="14" r="14" transform="translate(-0.096 -0.279) translate(46.346)"/>
						<Circle cx="14" cy="14" r="14" transform="translate(-0.442 -0.279) translate(92.691)"/>
					</G>
				</G>
			</Svg>
		)
	},

	chat: (color) => (
		<Svg viewBox="0 0 28.705 28.842">
			<Path
				fill="none"
				stroke={color}
				strokeWidth="1.5px"
				d="M13.609 0A13.61 13.61 0 0 0 0 13.6a13.542 13.542 0 0 0 1.536 6.292c.1.181.181.363.278.532a1.791 1.791 0 0 1 .121 1.355 26.623 26.623 0 0 0-.968 3.17c0 .532.157.847.726.847a25.918 25.918 0 0 0 3.048-.883A2.08 2.08 0 0 1 6.048 25c.375.194.714.472 1.089.641h.121A13.609 13.609 0 0 0 27.205 13.6 13.61 13.61 0 0 0 13.609 0z"
				transform="translate(.75 .75)"/>

			<G fill={color}>
				<Path d="M1.744 3.488A1.744 1.744 0 0 1 0 1.744a1.744 1.744 0 1 1 1.744 1.744z"
					  transform="translate(.75 .75) translate(5.434 12.242)"/>
				<Path d="M1.744 3.488A1.732 1.732 0 0 1 0 1.744a1.744 1.744 0 1 1 1.744 1.744z"
					  transform="translate(.75 .75) translate(11.564 12.242)"/>
				<Path d="M1.744 3.488A1.744 1.744 0 0 1 0 1.744a1.744 1.744 0 1 1 1.744 1.744z"
					  transform="translate(.75 .75) translate(17.682 12.242)"/>
			</G>
		</Svg>
	),

	"round-chat": (color, dotsColor = 'white') => (
		<Svg fill={color} viewBox="0 0 24 24">
			<Path
				d="M12.005 0A12.007 12.007 0 0 0 0 12a11.946 11.946 0 0 0 1.355 5.55c.085.16.16.32.245.47a1.58 1.58 0 0 1 .107 1.2 23.486 23.486 0 0 0-.854 2.8c0 .47.139.747.64.747a22.865 22.865 0 0 0 2.689-.779 1.835 1.835 0 0 1 1.153.075c.331.171.63.416.96.566H6.4A12.005 12.005 0 0 0 24 12 12.007 12.007 0 0 0 12.005 0z"/>
			<G fill={dotsColor}>
				<Path d="M1.5 3.005A1.5 1.5 0 0 1 0 1.5 1.5 1.5 0 1 1 1.5 3z"
					  transform="translate(4.81 10.837)"/>
				<Path d="M1.5 3.005A1.492 1.492 0 0 1 0 1.5 1.5 1.5 0 1 1 1.5 3z"
					  transform="translate(10.236 10.836)"/>
				<Path d="M1.5 3.005A1.5 1.5 0 0 1 0 1.5 1.5 1.5 0 1 1 1.5 3z"
					  transform="translate(15.652 10.837)"/>
			</G>
		</Svg>
	),

	"orders-list": (color) => (
		<Svg viewBox="0 0 23.509 16.153">
			<G transform="translate(.25 .25)" fill={color} stroke="#f7f7f7" strokeWidth={.5}>
				<Circle cx="1.827" cy="1.827" r="1.827"/>
				<Circle cx="1.827" cy="1.827" r="1.827" transform="translate(0 6)"/>
				<Circle cx="1.827" cy="1.827" r="1.827" transform="translate(0 12)"/>

				<G transform="translate(5.259 12.782)">
					<Rect width="9" height="3" rx="1.5" stroke="none"/>
					<Rect width="8.5" height="2.5" x=".25" y=".25" rx="1.25" fill="none"/>
				</G>

				<G transform="translate(14.259 12.782)">
					<Rect width="9" height="3" rx="1.5" stroke="none"/>
					<Rect width="8.5" height="2.5" x=".25" y=".25" rx="1.25" fill="none"/>
				</G>

				<G transform="translate(5.259 6.782)">
					<Rect width="18" height="3" rx="1.5" stroke="none"/>
					<Rect width="17.5" height="2.5" x=".25" y=".25" rx="1.25" fill="none"/>
				</G>

				<G transform="translate(5.259 .782)">
					<Rect width="18" height="3" rx="1.5" stroke="none"/>
					<Rect width="17.5" height="2.5" x=".25" y=".25" rx="1.25" fill="none"/>
				</G>
			</G>
		</Svg>
	),

	send: color => (
		<Svg viewBox="0 0 18 17.6">
			<Path
				fill={color}
				d="M0 16.3v-4.5a2.347 2.347 0 0 1 .214-.895A2.531 2.531 0 0 1 1 10.387L10.5 8.8H18l-.457.69L2.246 17.6zm10.5-7.5L1 7.214a3.244 3.244 0 0 1-.789-.571A2.3 2.3 0 0 1 0 5.8V1.3L2.246 0l15.3 8.109L18 8.8z"
			/>
		</Svg>
	),


	// ---- order ----
	orderValidated: (color = '#27ae60') => (
		<Svg viewBox="0 0 16.863 12.572">
			<Path id="Path_4400"
				  d="M7.633 17.813a1.958 1.958 0 0 1-2.769 0L.573 13.522a1.958 1.958 0 0 1 2.769-2.769L5.9 13.309a.5.5 0 0 0 .7 0l6.92-6.922a1.958 1.958 0 1 1 2.77 2.769z"
				  fill={color} transform="translate(0 -5.814)"/>
		</Svg>
	),

	orderPending: (color = '#ff9901') => (
		<Svg viewBox="0 0 14.153 14.951">
			<G fill={color}>
				<Path
					d="M130.4 120.32a.989.989 0 0 0 .726-.683l.367-1.08.148.05a.13.13 0 0 0 .165-.081l.2-.58a.13.13 0 0 0-.081-.165l-4.762-1.619a.13.13 0 0 0-.165.081l-.2.58a.13.13 0 0 0 .081.165l.148.05-.374 1.1a.8.8 0 0 0 .162.96l.964 1.154-.107.316c-.369.08-1.332.29-1.462.327a.989.989 0 0 0-.726.683l-.316.93-.148-.05a.13.13 0 0 0-.165.081l-.2.58a.13.13 0 0 0 .081.165l4.764 1.616a.13.13 0 0 0 .165-.081l.2-.579a.13.13 0 0 0-.081-.165l-.148-.05.323-.95a.8.8 0 0 0-.162-.96l-.964-1.154.107-.316a53.007 53.007 0 0 0 1.46-.325zm-2.013.842l1.048 1.255a.606.606 0 0 1 .135.2.67.67 0 0 1-.057.313l-.323.95-3.581-1.218.316-.93a.529.529 0 0 1 .413-.384c.1-.03.99-.224 1.56-.348a.234.234 0 0 0 .172-.153l.192-.565a.234.234 0 0 0-.042-.225l-1.045-1.251a.6.6 0 0 1-.135-.2.67.67 0 0 1 .057-.313l.374-1.1 3.581 1.218-.367 1.08a.529.529 0 0 1-.413.384c-.1.03-.99.224-1.56.348a.234.234 0 0 0-.172.153l-.192.565a.234.234 0 0 0 .041.221z"
					transform="translate(-121.212 -112.579)"/>
				<Path
					d="M22.965 13.042a4.83 4.83 0 0 1-.32.169q-.026.013-.051.028a.551.551 0 0 0-.052.021 5.868 5.868 0 0 1-1.459.461h-.019a6.204 6.204 0 0 1-.359.052 6.06 6.06 0 0 1-.665.037 5.948 5.948 0 0 1-5.6-3.963c-.012-.035-.025-.07-.036-.106A5.942 5.942 0 0 1 14.4 6l.013-.039.036-.1.017-.048a5.963 5.963 0 0 1 4.143-3.7l.085-.02h.009a5.936 5.936 0 0 1 1.3-.149l.005.611c0 .19.121.244.266.122l1.29-1.093a.277.277 0 0 0 0-.441L20.255.062c-.147-.12-.265-.063-.264.126L20 .8a7.029 7.029 0 0 0-4.967 2.07q-.2.2-.375.4l-.013.016a7.018 7.018 0 0 0-1.68 4.374v.201c0 .089 0 .179.005.268v.031a7.014 7.014 0 0 0 1.463 4.04l.009.012c.088.113.18.225.275.332l.019.02q.144.162.3.317a7.024 7.024 0 0 0 3.81 1.973h.023a7.168 7.168 0 0 0 1.171.1 7.018 7.018 0 0 0 2.987-.66.564.564 0 0 0 .058-.032.549.549 0 0 0 .062-.026c.129-.063.257-.13.382-.2a.569.569 0 1 0-.561-.99z"
					transform="translate(-12.959 .001)"/>
				<Path
					d="M392.648 110.123a.569.569 0 1 0 .945-.635 7.236 7.236 0 0 0-.252-.351.569.569 0 1 0-.9.691c.069.096.14.195.207.295z"
					transform="translate(-380.639 -105.56)"/>
				<Path
					d="M425.588 173.327c.037.114.07.231.1.348a.569.569 0 0 0 1.1-.281 6.527 6.527 0 0 0-.119-.414.569.569 0 1 0-1.084.347z"
					transform="translate(-412.856 -167.27)"/>
				<Path
					d="M376.6 375.778a.569.569 0 0 0-.8.058 6.197 6.197 0 0 1-.245.267.569.569 0 1 0 .814.8c.1-.1.2-.209.292-.318a.569.569 0 0 0-.061-.807z"
					transform="translate(-364.227 -364.073)"/>
				<Path
					d="M435.469 243.728a.569.569 0 0 0-.586.552c0 .12-.011.242-.022.362a.569.569 0 0 0 .515.619h.053a.569.569 0 0 0 .566-.517c.013-.143.022-.288.026-.432a.569.569 0 0 0-.552-.584z"
					transform="translate(-421.868 -236.223)"/>
				<Path
					d="M417.1 314.163a.569.569 0 0 0-.737.322 6.525 6.525 0 0 1-.142.333.569.569 0 1 0 1.033.478c.06-.13.117-.263.169-.4a.569.569 0 0 0-.323-.733z"
					transform="translate(-403.753 -304.451)"/>
				<Path
					d="M340.95 61.24a.569.569 0 0 0-.119-.8 7.203 7.203 0 0 0-.354-.246.569.569 0 0 0-.62.954c.1.066.2.135.3.207a.569.569 0 0 0 .8-.119z"
					transform="translate(-329.541 -58.255)"/>
			</G>
		</Svg>
	),

	orderCanceled: (color = '#f42d55') => (
		<Svg viewBox="0 0 20.263 20.263">
			<G fill={color} stroke={color} strokeWidth={.5} transform="translate(.25 .25)">
				<Path
					d="M9.881 0a9.881 9.881 0 1 0 9.881 9.881A9.892 9.892 0 0 0 9.881 0zm0 18.939a9.058 9.058 0 1 1 9.058-9.058 9.068 9.068 0 0 1-9.058 9.058z"
				/>
				<Path
					d="M245.715 85.333a.35.35 0 0 0-.382.306v7.348a.391.391 0 0 0 .764 0v-7.348a.35.35 0 0 0-.382-.306z"
					transform="translate(-235.834 -80.659)"/>
				<Circle
					cx={.382} cy={.382} r={.382}
					transform="translate(9.499 14.597)"/>
			</G>
		</Svg>

	),

	person: (color) => (
		<Svg viewBox="0 0 15.464 15.464">
			<Path
				d="M13.2 10a7.7 7.7 0 0 0-2.938-1.843 4.47 4.47 0 1 0-5.058 0A7.744 7.744 0 0 0 0 15.464h1.208a6.524 6.524 0 1 1 13.048 0h1.208A7.682 7.682 0 0 0 13.2 10zM7.732 7.732a3.262 3.262 0 1 1 3.262-3.262 3.266 3.266 0 0 1-3.262 3.262z"
				fill={color}/>
		</Svg>
	),

	star: (...colors) => {
		if (!colors.first)
			colors = ['#ff9901'];

		let gradientId = "colors" + Generator.number;

		return (
			<Svg viewBox="0 0 20 20">
				<Defs>
					<LinearGradient id={gradientId} x1=".5" x2=".5" y2="1" gradientUnits="objectBoundingBox">
						<Stop offset="0" stopColor={colors.first}/>
						<Stop offset="1" stopColor={colors.last}/>
					</LinearGradient>
				</Defs>
				<Path
					d="M19.565 9.731a1.434 1.434 0 0 0-.8-2.447l-4.843-.7a.633.633 0 0 1-.477-.346l-2.159-4.392a1.434 1.434 0 0 0-2.572 0L6.548 6.234a.633.633 0 0 1-.477.346l-4.843.7a1.434 1.434 0 0 0-.8 2.447l3.5 3.415a.634.634 0 0 1 .183.561l-.827 4.823a1.4 1.4 0 0 0 .313 1.163 1.449 1.449 0 0 0 1.768.349L9.7 17.764a.648.648 0 0 1 .59 0l4.331 2.277a1.419 1.419 0 0 0 .667.167 1.438 1.438 0 0 0 1.1-.516 1.4 1.4 0 0 0 .313-1.163l-.827-4.823a.634.634 0 0 1 .183-.561z"
					fill={`url(#${gradientId})`}
					transform="translate(.001 -1.047)"/>
			</Svg>
		);
	},

	location: (...colors) => {
		let gradientId = "colors" + Generator.number;

		return (
			<Svg viewBox="0 0 28.394 40.935">
				<Defs>
					<LinearGradient id={gradientId} x2="0" y2="100%">
						<Stop offset="0" stopColor={colors.first}/>
						<Stop offset="1" stopColor={colors.last}/>
					</LinearGradient>
				</Defs>
				<Path fill={`url(#${gradientId})`}
					  d="M150.2 0a14.2 14.2 0 0 0-12.02 21.76l12.02 19.175 12.014-19.175A14.2 14.2 0 0 0 150.2 0zm0 23.07a8.873 8.873 0 1 1 8.87-8.87 8.884 8.884 0 0 1-8.87 8.87zm0 0"
					  transform="translate(-136)"/>
			</Svg>
		);
	},

	rightArrow: (color) => (
		<Svg fill={color || "#fff"} viewBox="0 0 22.426 15.433">
			<Path transform="translate(0 -41.916)"
				  d="M22.121 48.9l-6.674-6.674a1.043 1.043 0 1 0-1.475 1.474l4.894 4.894H1.043a1.043 1.043 0 1 0 0 2.086h17.823l-4.893 4.894a1.043 1.043 0 0 0 1.475 1.475l6.674-6.674a1.043 1.043 0 0 0-.001-1.475z"
			/>
		</Svg>
	),

	leftArrow: (color) => (
		<Svg fill={color || "#fff"} viewBox="0 0 22.426 15.433">
			<Path transform="rotate(180 11.213 28.674)"
				  d="M22.121 48.9l-6.674-6.674a1.043 1.043 0 1 0-1.475 1.474l4.894 4.894H1.043a1.043 1.043 0 1 0 0 2.086h17.823l-4.893 4.894a1.043 1.043 0 0 0 1.475 1.475l6.674-6.674a1.043 1.043 0 0 0-.001-1.475z"
			/>
		</Svg>
	),
	creditCard: (color) => {
		color = ["#e7e8e3", "#34495e", "#fff", "", "#202121", "#ea001b", "#f79f1a", "#ff5f01"];
		return (
			<Svg viewBox="0 0 30.632 21.425">
				<G transform="translate(0 -76.943)">
					<Path
						d="M37.748 103.731a1.754 1.754 0 0 1-1.753 1.754H9.837a1.754 1.754 0 0 1-1.753-1.754v-16.95a1.753 1.753 0 0 1 1.753-1.754h26.158a1.754 1.754 0 0 1 1.753 1.754v16.951z"
						fill={color[0]} transform="translate(-7.6 -7.6)"/>
					<Path d="M0 0h29.664v4.172H0z" fill={color[1]} transform="translate(.483 81.406)"/>
					<Path d="M0 0h29.664v2.582H0z" fill={color[2]} transform="translate(.483 85.579)"/>
					<G opacity={.15} transform="translate(.484 77.427)">
						<Path
							d="M9.331 103.731v-16.95a1.754 1.754 0 0 1 1.754-1.754H9.837a1.754 1.754 0 0 0-1.753 1.754v16.951a1.754 1.754 0 0 0 1.753 1.754h1.247a1.754 1.754 0 0 1-1.753-1.755z"
							fill={color[4]} transform="translate(-8.084 -85.027)"/>
					</G>
					<Path
						d="M316.353 301.7a2.767 2.767 0 0 1 1.028-2.155 2.773 2.773 0 1 0 0 4.31 2.767 2.767 0 0 1-1.028-2.155z"
						fill={color[5]} transform="translate(-294.145 -208.705)"/>
					<Path
						d="M390.127 298.928a2.761 2.761 0 0 0-1.745.618 2.773 2.773 0 0 1 0 4.31 2.773 2.773 0 1 0 1.745-4.928z"
						fill={color[6]} transform="translate(-365.146 -208.704)"/>
					<Path d="M373.256 311.416a1.323 1.323 0 1 0-1.028 2.155 2.767 2.767 0 0 0 1.028-2.155z"
						  fill={color[7]} transform="translate(-348.992 -218.419)"/>
					<G transform="translate(0 76.943)">
						<Path
							d="M308.036 297.358a3.257 3.257 0 1 1 2.05-5.787.484.484 0 0 1 0 .751 2.289 2.289 0 0 0 0 3.559.484.484 0 0 1 0 .751 3.264 3.264 0 0 1-2.05.726zm0-5.546a2.289 2.289 0 1 0 0 4.579 2.268 2.268 0 0 0 .977-.218 3.259 3.259 0 0 1 0-4.144 2.269 2.269 0 0 0-.977-.217z"
							fill={color[4]} transform="translate(-286.545 -278.048)"/>
						<Path
							d="M382.527 297.358a3.264 3.264 0 0 1-2.05-.726.484.484 0 0 1 0-.751 2.289 2.289 0 0 0 0-3.558.484.484 0 0 1 0-.751 3.257 3.257 0 1 1 2.05 5.787zm-.977-1.185a2.289 2.289 0 1 0 0-4.144 3.259 3.259 0 0 1 0 4.144z"
							fill={color[4]} transform="translate(-357.546 -278.048)"/>
						<Path
							d="M364.628 306.454a.483.483 0 0 1-.3-.108 3.256 3.256 0 0 1 0-5.061.484.484 0 0 1 .609 0 3.256 3.256 0 0 1 0 5.061.483.483 0 0 1-.309.108zm0-4.121a2.29 2.29 0 1 0 .544 1.482 2.279 2.279 0 0 0-.544-1.482z"
							fill={color[4]} transform="translate(-341.392 -287.762)"/>
						<Path
							d="M30.148 80.321a.484.484 0 0 0 .484-.484v-.657a2.24 2.24 0 0 0-2.237-2.237H2.237A2.24 2.24 0 0 0 0 79.18v16.951a2.24 2.24 0 0 0 2.237 2.237h26.157a2.24 2.24 0 0 0 2.237-2.237V81.406a.484.484 0 0 0-.484-.484H.967V79.18a1.271 1.271 0 0 1 1.27-1.27h26.157a1.271 1.271 0 0 1 1.27 1.27v.657a.484.484 0 0 0 .484.484zm-.484 7.356H.967v-1.615h28.7v1.614zm-1.27 9.723H2.237a1.271 1.271 0 0 1-1.27-1.27v-7.486h28.7v7.487a1.271 1.271 0 0 1-1.273 1.269zm1.27-15.511V85.1H.967v-3.21z"
							fill={color[4]} transform="translate(0 -76.943)"/>
						<Path d="M60.232 305.414h-6.061a.484.484 0 0 1 0-.967h6.062a.484.484 0 0 1 0 .967z"
							  fill={color[4]} transform="translate(-50.475 -290.836)"/>
						<Path d="M60.232 339.018h-6.061a.484.484 0 0 1 0-.967h6.062a.484.484 0 0 1 0 .967z"
							  fill={color[4]} transform="translate(-50.475 -322.43)"/>
						<Path d="M60.232 372.621h-6.061a.484.484 0 0 1 0-.967h6.062a.484.484 0 0 1 0 .967z"
							  fill={color[4]} transform="translate(-50.475 -354.022)"/>
					</G>
				</G>
			</Svg>
		)
	},

	back: color => (
		<Svg fill={color} viewBox="0 0 11.118 19.891">
			<Path
				d="M163.36 98.03l7.358-7.52a1.438 1.438 0 0 0 0-2.007 1.374 1.374 0 0 0-1.968 0l-8.337 8.521a1.442 1.442 0 0 0-.041 1.96l8.371 8.58a1.376 1.376 0 0 0 1.968 0 1.438 1.438 0 0 0 0-2.007z"
				transform="translate(-160.009 -88.088)"/>
		</Svg>
	),

	delete: color => (
		<Svg viewBox="0 0 16.829 18.563" fill={color}>
			<Path
				d="M222.884 154.7a.462.462 0 0 0-.485.435v8.216a.488.488 0 0 0 .971 0v-8.216a.462.462 0 0 0-.486-.435zm0 0"
				transform="translate(-211.609 -147.979)"/>
			<Path
				d="M104.884 154.7a.462.462 0 0 0-.485.435v8.216a.488.488 0 0 0 .971 0v-8.216a.462.462 0 0 0-.486-.435zm0 0"
				transform="translate(-99.335 -147.979)"/>
			<Path
				d="M1.375 5.525v10.711a2.266 2.266 0 0 0 .712 1.654 2.529 2.529 0 0 0 1.734.672H13a2.528 2.528 0 0 0 1.734-.672 2.266 2.266 0 0 0 .712-1.654V5.525a1.675 1.675 0 0 0 1.363-1.82 1.8 1.8 0 0 0-1.838-1.446h-2.483v-.543A1.622 1.622 0 0 0 11.928.5a2.026 2.026 0 0 0-1.362-.5H6.257A2.026 2.026 0 0 0 4.9.5a1.622 1.622 0 0 0-.56 1.219v.543H1.851A1.8 1.8 0 0 0 .013 3.705a1.675 1.675 0 0 0 1.362 1.82zM13 17.692H3.821a1.448 1.448 0 0 1-1.475-1.456V5.563h12.131v10.673A1.448 1.448 0 0 1 13 17.692zM5.306 1.716a.794.794 0 0 1 .275-.6.994.994 0 0 1 .676-.248h4.309a.994.994 0 0 1 .676.244.794.794 0 0 1 .275.6v.543H5.306zM1.851 3.129h13.121a.832.832 0 0 1 .873.782.832.832 0 0 1-.873.782H1.851a.832.832 0 0 1-.873-.782.832.832 0 0 1 .873-.782zm0 0"
			/>
			<Path
				d="M163.884 154.7a.462.462 0 0 0-.485.435v8.216a.488.488 0 0 0 .971 0v-8.216a.462.462 0 0 0-.486-.435zm0 0"
				transform="translate(-155.472 -147.979)"/>
		</Svg>
	),


	...{

		'ReceptionMean.delivery': color => (
			<Svg viewBox="0 0 58 44.019" fill={color}>
				<G transform="translate(-682 -457.325)">
					<G transform="translate(693.434 457.325)">
						<Path
							d="M2.471 27.094h7.9a2.475 2.475 0 0 1 2.471 2.473v9.089h2.954a6.785 6.785 0 0 1-.185-2.12 19.824 19.824 0 0 1 1.867-8.671 9.3 9.3 0 0 1 2.89-3.484 6.325 6.325 0 0 1-1.695-4.481 5.788 5.788 0 1 1 11.573 0 .682.682 0 0 1-.682.682H29.1a4.8 4.8 0 0 1 .065.786 4.736 4.736 0 0 1-3.805 4.64 11.5 11.5 0 0 1 .34 2.967l1.7 1.463 4.14.335 4.776-1.573a1.446 1.446 0 0 1 1.364 0 1.212 1.212 0 0 1 .424 1.018v3.55a.682.682 0 0 1-.682.682h-.812l1.246 4.3a.682.682 0 0 1-1.311.379l-1.355-4.682h-1.939c2.412 7.355 1.036 12.265-1.08 17.233H33.4l5.1-5.71-1.08-3.731a.682.682 0 0 1 1.31-.379l1.033 3.569a6.861 6.861 0 0 1 6.781 5.318.682.682 0 0 1-.512.817l-.968.223a5.219 5.219 0 0 1-10.086 2.321l-.764.176a.891.891 0 0 1-.659-.037.783.783 0 0 1-.384-.523 6.786 6.786 0 0 1-.11-.679H18.8a5.813 5.813 0 0 1-11.5 0h-.653a.934.934 0 0 1-.708-.257.874.874 0 0 1-.241-.663 7.733 7.733 0 0 1 .279-1.848 10.642 10.642 0 0 1 .754-6.88 1.8 1.8 0 0 1-.815-1.5V40.02H2.471A2.475 2.475 0 0 1 0 37.547v-7.98a2.474 2.474 0 0 1 2.471-2.473zm35.356 28.461a3.826 3.826 0 0 0 2.909.49 3.865 3.865 0 0 0 2.989-3.945l-7.4 1.7a3.835 3.835 0 0 0 1.502 1.755zm-3.413-2.716L45.025 50.4a5.493 5.493 0 0 0-5.431-3.6L34.4 52.61q0 .115.014.229zm-10.3-11.887a6.073 6.073 0 0 1 .2 2.057v2.574h2.5v-3.531c0-3.992-2.179-4.7-3.157-4.821h-6.695a2.892 2.892 0 0 0 .62 1.959 3.167 3.167 0 0 0 2.367.71h2.448a1.643 1.643 0 0 1 1.714 1.05zm.2 6v1.629h4.864a1.944 1.944 0 0 0-.47-1.167 1.683 1.683 0 0 0-1.214-.462zm-7.321-11.085h6.2a25.47 25.47 0 0 0 .654-2.524l-1.886-1.224a2.815 2.815 0 0 1-1.469-2.592A2.412 2.412 0 0 1 22 27.552a2.462 2.462 0 0 1 2.289.252 8.054 8.054 0 0 0-.329-1.729 4.808 4.808 0 0 1-.863-.17 5.651 5.651 0 0 1-1.592-.631c-1.317.784-4.205 3.326-4.512 10.593zM28.832 19.22a4.416 4.416 0 0 0-8.8.682 4.632 4.632 0 0 0 2.549 4.4v-3.593a1.357 1.357 0 0 1 1.371-1.487h.062zM27.8 21.37a3.4 3.4 0 0 0-.091-.786h-3.657c-.042 0-.073.009-.095.014a.811.811 0 0 0-.007.112v3.99a3.374 3.374 0 0 0 .489.036A3.367 3.367 0 0 0 27.8 21.37zm.884 10.543l-1.616-.131a.682.682 0 0 1-.39-.163l-2.916-2.508a1.355 1.355 0 0 0-.876-.368 1.05 1.05 0 0 0-1.036.915 1.5 1.5 0 0 0 .855 1.315l3.249 2.109h2.73v-1.17zm2.883.233l-1.518-.123v1.06h1.765c.229 0 .284-.19.291-.35a.542.542 0 0 0-.536-.587zm1.614-.471a1.97 1.97 0 0 1 .251 1.4v.006h3.3v-2.59l-3.551 1.179v.005zm-1.372 2.772h-6.055a.682.682 0 0 1-.371-.11l-.309-.2c-.149.656-.318 1.3-.5 1.9 1.391.411 3.6 1.738 3.6 6.017v3.6a2.847 2.847 0 0 1 1.518.815 3.327 3.327 0 0 1 .853 2.109h1.376a20.06 20.06 0 0 0-.11-14.131zm-1.122 17.231c.252-.58.5-1.157.724-1.737h-7.083c-.918 0-1.383-.418-1.383-1.242v-5.007h-5.384a.682.682 0 0 1 0-1.364h5.379a3.088 3.088 0 0 0-.1-.891c-.034-.091-.064-.17-.439-.17h-2.449a4.4 4.4 0 0 1-3.355-1.134l-.1-.109H7.281v1.875a.438.438 0 0 0 .432.433H14.5a.682.682 0 1 1 0 1.364H8.113a8.053 8.053 0 0 0-1 4.213 7.4 7.4 0 0 1 11.275-.88 7.515 7.515 0 0 1 2.144 4.656zm-17.64 4.977a4.5 4.5 0 0 0 4.366-3.61H8.681a4.5 4.5 0 0 0 4.365 3.61zM7.906 51.68h11.261a6.118 6.118 0 0 0-6.036-5.491 6.052 6.052 0 0 0-5.8 4.337l-.008.024a6.3 6.3 0 0 0-.225 1.13zM1.364 37.547a1.109 1.109 0 0 0 1.107 1.108h9v-3.522H1.364zm0-3.778h10.111v-1.451H1.364zm0-2.815h10.111v-1.387a1.109 1.109 0 0 0-1.107-1.108h-7.9a1.109 1.109 0 0 0-1.107 1.108z"
							transform="translate(0 -14)"/>
					</G>

					<Rect width="14" height="1" rx=".5" transform="translate(682 488)"/>
					<Rect width="11" height="1" rx=".5" transform="translate(685 490)"/>
					<Rect width="6" height="1" rx=".5" transform="translate(690 492)"/>
				</G>
			</Svg>
		),
		'ReceptionMean.collect': color => (
			<Svg viewBox="0 0 44.788 40.24" fill={color}>
				<Path
					d="M44.693 38.457l-4.209-8.295v-3.29a.875.875 0 0 0-.875-.872H5.178a.875.875 0 0 0-.875.875v3.29L.095 38.457a.875.875 0 0 0-.095.4v2.152a5.186 5.186 0 0 0 4.3 5.1v18.379h-.9a.875.875 0 0 0 0 1.75h37.98a.875.875 0 0 0 0-1.75h-.9v-18.38a5.186 5.186 0 0 0 4.3-5.1v-2.155a.874.874 0 0 0-.087-.396zM6.053 27.748h32.682V29.5H6.053zm21.515 11.017l-.763-7.518h5.27l2.355 7.736v2.022a3.429 3.429 0 0 1-6.858 0v-2.152a.878.878 0 0 0-.004-.088zm-1.745.133v2.108a3.429 3.429 0 0 1-6.858 0V38.9l.777-7.651h5.305zm-7.84-7.65l-.763 7.518a.85.85 0 0 0 0 .088v2.152a3.429 3.429 0 0 1-6.858 0v-2.023l2.356-7.736zM1.75 41.005v-1.943l3.966-7.816h5.168L8.646 38.6a.876.876 0 0 0-.038.255v2.152a3.429 3.429 0 0 1-6.858 0zm33.486 23.483h-5.249v-6.123h.875a.875.875 0 1 0 0-1.75h-.875v-6.123h5.249zm3.5 0h-1.75V49.617a.875.875 0 0 0-.875-.875H8.678a.875.875 0 0 0-.875.875v12.247a.875.875 0 0 0 .875.875h19.56v1.75H6.053V46.108a5.188 5.188 0 0 0 3.429-2.227 5.174 5.174 0 0 0 8.608 0 5.174 5.174 0 0 0 8.608 0 5.174 5.174 0 0 0 8.608 0 5.188 5.188 0 0 0 3.429 2.227v18.38zm-20.651-14h3.048l-1.663 1.663a.875.875 0 1 0 1.237 1.237l2.9-2.9h4.631v10.5H9.552v-1.964zm-8.533 6.061v-6.057h6.058zm33.487-15.544a3.429 3.429 0 0 1-6.858 0v-2.152a.873.873 0 0 0-.038-.255L33.9 31.247h5.168l3.966 7.816z"
					transform="translate(0 -25.998)"/>
				<Path
					d="M200.018 344.164a.872.872 0 0 0 .617-.254l.015-.015a.875.875 0 1 0-1.234-1.241l-.015.015a.875.875 0 0 0 .617 1.5z"
					transform="translate(-181.723 -314.722)"/>
				<Path d="M.9 466H.875a.875.875 0 1 0 0 1.75H.9a.875.875 0 1 0 0-1.75z"
					  transform="translate(0 -427.506)"/>
				<Path d="M492.657 466h-.021a.875.875 0 1 0 0 1.75h.021a.875.875 0 0 0 0-1.75z"
					  transform="translate(-448.744 -427.51)"/>
			</Svg>
		),
	},

	...{
		'PaymentMean.online': color => (
			<Svg viewBox="0 0 48.548 48.753" fill={color}>
				<G transform="rotate(90 24.274 24.274)">
					<G transform="translate(2.825 5.242)">
						<Path
							d="M43.883 46.729a.79.79 0 0 0-1.113-.1l-11.257 9.385a.662.662 0 0 0-.058.053 4.873 4.873 0 0 0-1.4 3.434v20.93a.79.79 0 1 0 1.58 0V59.5a3.3 3.3 0 0 1 .926-2.3l11.226-9.36a.79.79 0 0 0 .096-1.111zm0 0"
							transform="translate(-29.485 -46.445)"/>
						<Path
							d="M177.018 194.883a.79.79 0 0 0-.79.79v8.222a3.325 3.325 0 0 1-3.321 3.321.79.79 0 0 0-.79.79v4.111a.79.79 0 0 0 1.58 0v-3.385a4.909 4.909 0 0 0 4.111-4.837v-8.222a.79.79 0 0 0-.79-.79zm0 0"
							transform="translate(-155.518 -178.131)"/>
						<Path
							d="M27.47 369.937a2.384 2.384 0 1 1 2.332-2.383 2.383 2.383 0 0 1-2.332 2.383zm0-3.186a.8.8 0 1 0 .752.8.78.78 0 0 0-.752-.8zm0 0"
							transform="translate(-25.034 -329.2)"/>
						<Path
							d="M303.778 115.652a3.327 3.327 0 0 0-1.542.374 3.359 3.359 0 1 0 0 5.97 3.359 3.359 0 1 0 1.542-6.344zm-4.862 3.359a1.779 1.779 0 1 1 1.779 1.78 1.78 1.78 0 0 1-1.779-1.78zm4.862 1.78a1.786 1.786 0 0 1-.227-.015l.022-.038c.024-.04.047-.08.069-.121l.037-.069.065-.135c.009-.02.019-.039.027-.06.029-.065.056-.132.08-.2l.006-.018c.022-.061.042-.123.06-.186l.019-.069c.013-.046.025-.093.035-.14l.016-.079.025-.137c0-.026.008-.053.011-.08.007-.049.011-.1.016-.147 0-.023 0-.046.006-.069 0-.072.008-.145.008-.218s0-.147-.008-.22c0-.023 0-.046-.006-.07 0-.05-.009-.1-.015-.149 0-.027-.008-.053-.011-.08l-.024-.138-.016-.079c-.011-.048-.022-.094-.035-.142l-.018-.068c-.018-.063-.038-.124-.06-.186l-.006-.018c-.024-.067-.051-.133-.079-.2l-.029-.061c-.02-.045-.041-.088-.063-.131l-.038-.071-.067-.116-.022-.04a1.78 1.78 0 1 1 .222 3.545zm0 0"
							transform="translate(-266.605 -107.841)"/>
					</G>
					<Path
						d="M22.887 340.594H.79a.79.79 0 0 0-.79.79v8.53a.79.79 0 0 0 .79.79h22.1a.79.79 0 0 0 .79-.79v-8.53a.79.79 0 0 0-.793-.79zm-.79 8.53H1.58v-6.95H22.1zm0 0"
						transform="translate(0 -302.156)"/>
					<Path
						d="M168.271 0h-23.124a4.906 4.906 0 0 0-4.9 4.9v10.516a.79.79 0 0 0 1.58 0v-4.072h29.766v6.3a3.325 3.325 0 0 1-3.321 3.321h-23.125a3.284 3.284 0 0 1-2.072-.726.79.79 0 1 0-.987 1.233 4.914 4.914 0 0 0 3.059 1.072h23.124a4.906 4.906 0 0 0 4.9-4.9V4.9a4.906 4.906 0 0 0-4.9-4.9zm3.321 9.764h-29.766V7.232h29.766zm0-4.111h-29.766V4.9a3.325 3.325 0 0 1 3.321-3.321h23.124a3.324 3.324 0 0 1 3.321 3.321zm0 0"
						transform="translate(-124.419)"/>
					<Path
						d="M88.651 123.061l.036-.626 4.148-4.148a3.878 3.878 0 0 0 0-5.477l-.727-.727a.789.789 0 0 0-1.049-.06l-9.873 7.817a.79.79 0 0 0 .981 1.239l9.322-7.381.229.229a2.3 2.3 0 0 1 0 3.243l-4.36 4.36a.789.789 0 0 0-.23.513l-.055.951v.046a4.879 4.879 0 0 0 .482 2.085 4.794 4.794 0 0 1-.355 4.675.79.79 0 0 0-.133.438v2.055a.79.79 0 0 0 1.58 0v-1.825a6.386 6.386 0 0 0 .332-6.012 3.318 3.318 0 0 1-.328-1.395zm0 0"
						transform="translate(-71.757 -99.228)"/>
				</G>
			</Svg>
		),

		'PaymentMean.online-mobile': color => (
			<Svg viewBox="0 0 13.556 22" fill={color}>
				<G transform="translate(-6.277 -2)">
					<Path
						d="M18.073 24H8.037a1.76 1.76 0 0 1-1.76-1.76V3.76A1.76 1.76 0 0 1 8.037 2h10.036a1.76 1.76 0 0 1 1.76 1.76v18.48a1.76 1.76 0 0 1-1.76 1.76zM8.037 2.629A1.131 1.131 0 0 0 6.906 3.76v18.48a1.131 1.131 0 0 0 1.131 1.131h10.036A1.131 1.131 0 0 0 19.2 22.24V3.76a1.131 1.131 0 0 0-1.131-1.131z"/>
					<Path d="M19.519 12.281H6.593a.314.314 0 1 1 0-.629h12.926a.314.314 0 0 1 0 .629z"
						  transform="translate(-.001 -6.619)"/>
					<Path d="M19.519 57.923H6.593a.314.314 0 1 1 0-.629h12.926a.314.314 0 1 1 0 .629z"
						  transform="translate(-.001 -37.916)"/>
					<Path
						d="M25.19 63.368h-1.147a.905.905 0 0 1 0-1.811h1.147a.905.905 0 1 1 0 1.811zm-1.147-1.182a.277.277 0 1 0 0 .554h1.147a.277.277 0 0 0 0-.554z"
						transform="translate(-11.562 -40.839)"/>
					<Path d="M26.1 7.391h-1.786a.314.314 0 0 1 0-.629H26.1a.314.314 0 0 1 0 .629z"
						  transform="translate(-12.153 -3.265)"/>
				</G>
			</Svg>
		),

		'PaymentMean.card': color => (
			<Svg viewBox="0 0 21.177 14.471" fill={color}>
				<G transform="rotate(-90 7.236 7.236)">
					<Path
						d="M1.765 0A1.767 1.767 0 0 0 0 1.765a1.748 1.748 0 0 0 .361 1.059 1.765 1.765 0 1 0 2.807 0 1.748 1.748 0 0 0 .362-1.059A1.767 1.767 0 0 0 1.765 0zm0 .706a1.055 1.055 0 0 1 .7 1.848.006.006 0 0 0-.006 0 1.076 1.076 0 0 1-.441.232c-.01 0-.02.007-.03.009a1.023 1.023 0 0 1-.443 0c-.01 0-.02-.007-.03-.009a1.078 1.078 0 0 1-.441-.232h-.006a1.055 1.055 0 0 1 .7-1.848zm0 4.235A1.059 1.059 0 0 1 .706 3.882a1.028 1.028 0 0 1 .184-.59c.024.014.05.024.074.035a1.74 1.74 0 0 0 .251.106c.039.013.078.026.117.035.057.014.115.025.174.035.035.005.071.008.106.01.051 0 .1.016.152.016s.1-.011.152-.016c.035 0 .07-.005.106-.01a1.469 1.469 0 0 0 .178-.034c.04-.01.078-.024.117-.035a1.732 1.732 0 0 0 .251-.106c.025-.013.05-.023.074-.035a1.029 1.029 0 0 1 .185.59 1.059 1.059 0 0 1-1.062 1.058zm0 0"
						transform="translate(1.412 10.588)"/>
					<Path d="M0 0h.706v1.412H0zm0 0"
						  transform="translate(4.588 1.765)"/>
					<Path d="M0 0h.706v1.412H0zm0 0"
						  transform="translate(2.471 1.765)"/>
					<Path d="M0 0h.706v1.412H0zm0 0"
						  transform="translate(2.471 8.118)"/>
					<Path d="M0 0h.706v1.412H0zm0 0"
						  transform="translate(4.588 3.882)"/>
					<Path d="M0 0h.706v1.412H0zm0 0"
						  transform="translate(4.588 6)"/>
					<Path d="M0 0h.706v1.412H0zm0 0"
						  transform="translate(4.588 8.118)"/>
					<Path
						d="M14.471 20.824v-8.1a3.883 3.883 0 0 0-.96-2.557l-2.217-2.535V1.765A1.767 1.767 0 0 0 9.53 0H1.765A1.767 1.767 0 0 0 0 1.765v14.118a1.767 1.767 0 0 0 1.765 1.765h7.144a4.573 4.573 0 0 0 .267 1.116v2.061a.353.353 0 0 0 .353.353h4.588a.353.353 0 0 0 .354-.354zM12.979 10.63a3.175 3.175 0 0 1 .786 2.091v5.632H9.782a3.877 3.877 0 0 1 .207-2.953l.209-.418a.353.353 0 0 0-.066-.407l-3-3a.9.9 0 0 1 0-1.266.917.917 0 0 1 1.266 0l3.702 3.706.5-.5-1.308-1.308V8.7zM.706 15.883V1.765A1.059 1.059 0 0 1 1.765.706H9.53a1.059 1.059 0 0 1 1.059 1.059V11.5L8.9 9.809a1.6 1.6 0 1 0-2.264 2.264l2.82 2.82-.095.19a4.585 4.585 0 0 0-.48 1.858H1.765a1.059 1.059 0 0 1-1.059-1.058zm13.059 4.588H9.883v-1.412h3.882zm0 0"
					/>
				</G>
			</Svg>
		),

		'PaymentMean.cash': color => (
			<Svg viewBox="0 0 17.281 17.281" fill={color}>
				<G transform="translate(.3 .3)">
					<Path
						d="M78.589 320.932l-.734-.44a1.444 1.444 0 0 0-.74-.2h-1.1a2.607 2.607 0 0 0-.67.086l-3.326.893a1.16 1.16 0 0 0-.783.726l-2.926-1.583a1.146 1.146 0 0 0-.783-.129 1.081 1.081 0 0 0-.291.1 1.132 1.132 0 0 0-.495.461 1.154 1.154 0 0 0-.152.573 1.142 1.142 0 0 0 .569 1l5.244 3.137a1.441 1.441 0 0 0 .758.216h4.058a1.436 1.436 0 0 0 .529-.1l.845-.334v.435h2.88V320h-2.88zm-1.057 4.192a.866.866 0 0 1-.317.06h-4.059a.866.866 0 0 1-.459-.132l-5.251-3.141a.573.573 0 0 1-.286-.5.585.585 0 0 1 .077-.288.567.567 0 0 1 .247-.228.543.543 0 0 1 .144-.047.6.6 0 0 1 .11-.01.565.565 0 0 1 .282.075l3.173 1.714c0 .018 0 .035.008.052a1.155 1.155 0 0 0 1.114.853 2.839 2.839 0 0 0 .475-.085l2.992-.8-.149-.557-2.983.8c-.131.03-.3.065-.336.068a.576.576 0 0 1-.557-.424.527.527 0 0 1-.017-.107v-.094a.582.582 0 0 1 .424-.508l3.325-.89a2.013 2.013 0 0 1 .52-.068h1.1a.864.864 0 0 1 .444.123l1.03.616v3.1zm1.633-4.548h1.728v4.608h-1.728zm0 0"
						transform="translate(-64.188 -308.479)"/>
					<Path
						d="M11.879 2.3L10.334.759A2.574 2.574 0 0 0 8.5 0H4.88a1.45 1.45 0 0 0-.644.152l-.645.323a.854.854 0 0 1-.418.09L2.88.555V0H0v6.336h2.88v-.864h.49l.174.115a3.175 3.175 0 0 0 1.64.528v3.677h12.1V2.3zM2.3 5.76H.576V.576H2.3zm1.559-.652L3.543 4.9H2.88V1.131l.272.01a1.446 1.446 0 0 0 .7-.151l.641-.323A.866.866 0 0 1 4.88.576H8.5a2 2 0 0 1 1.426.59L11.064 2.3H8.688l-.7-.7-.407.407 2.035 2.04a.578.578 0 1 1-.815.818l-1.7-1.7-.2.173a1.527 1.527 0 0 1-1.941.029l-.167-.135-.363.447.169.137a2.1 2.1 0 0 0 .587.331v1.392a2.6 2.6 0 0 1-1.323-.431zm4.1-.27l.435.435a1.16 1.16 0 0 0 1.627 0 1.458 1.458 0 1 0 .164-.209 1.133 1.133 0 0 0 .094-1.034h3.857a1.733 1.733 0 0 0 1.416 1.416v1.2a1.733 1.733 0 0 0-1.416 1.416H8.329a1.733 1.733 0 0 0-1.417-1.414v-1.2a1.719 1.719 0 0 0 1.048-.61zm2.409 1.21a.864.864 0 1 1 .864.864.864.864 0 0 1-.863-.864zm6.336 3.168H5.76V4.268a2.094 2.094 0 0 0 1.3-.331l.491.491a1.149 1.149 0 0 1-.923.468h-.292V7.2h.288a1.152 1.152 0 0 1 1.152 1.152v.288h6.912v-.288A1.152 1.152 0 0 1 15.841 7.2h.288V4.9h-.288a1.152 1.152 0 0 1-1.152-1.152v-.292H9.84l-.576-.576h7.441zm0 0"/>
				</G>

				<G transform="translate(-30.578 -581.286)">
					<G transform="translate(43.751 587.193)">
						<Path
							d="M.7.909A.381.381 0 0 1 .366.7H.7V.586H.328a.386.386 0 0 1 0-.059.386.386 0 0 1 0-.059H.7V.352H.366A.381.381 0 0 1 .952.238l.1-.1a.527.527 0 0 0-.845.214H0v.117h.179a.49.49 0 0 0 0 .117H0V.7h.207a.527.527 0 0 0 .849.217l-.1-.1A.379.379 0 0 1 .7.909z"/>
					</G>
				</G>
			</Svg>
		),

		'PaymentMean.check': color => (
			<Svg viewBox="0 0 20.689 14.776" fill={color}>
				<G transform="translate(0 -72.916)">
					<Path d="M34.746 309.85h8.208a.3.3 0 1 0 0-.608h-8.208a.3.3 0 1 0 0 .608z"
						  transform="translate(-33.046 -226.744)"/>
					<Path
						d="M197.12 344.639c.075.259.153.527.421.527.145 0 .243 0 1.393-1.343a2.5 2.5 0 0 0 1.531.963.84.84 0 0 0 .095-.005 1.745 1.745 0 0 0 .873-.477c.452-.375.533-.371.711-.187a1.436 1.436 0 0 0 1.819.234.3.3 0 1 0-.329-.511.829.829 0 0 1-1.053-.147.838.838 0 0 0-.888-.268 1.989 1.989 0 0 0-.648.412 1.332 1.332 0 0 1-.553.34c-.338.039-.983-.58-1.312-1.011a.3.3 0 0 0-.474-.012c-.357.422-.771.892-1.04 1.18-.1-.375-.236-.974-.343-1.5a.3.3 0 0 0-.583-.044l-.746 2.028a.3.3 0 1 0 .571.21l.386-1.05c.064.274.121.498.169.661z"
						transform="translate(-188.028 -258.737)"/>
					<Path d="M34.746 276.112h8.208a.3.3 0 1 0 0-.608h-8.208a.3.3 0 1 0 0 .608z"
						  transform="translate(-33.046 -194.374)"/>
					<Path
						d="M35.209 199.831h10.5a.767.767 0 0 0 .766-.766v-.886a.767.767 0 0 0-.766-.766h-10.5a.767.767 0 0 0-.766.766v.886a.767.767 0 0 0 .766.766zm-.158-1.653a.158.158 0 0 1 .158-.158h10.5a.158.158 0 0 1 .158.158v.886a.158.158 0 0 1-.158.158h-10.5a.158.158 0 0 1-.158-.158v-.886z"
						transform="translate(-33.046 -119.448)"/>
					<Path
						d="M224.09 389.135a.3.3 0 0 0-.3.3v.721a.323.323 0 0 1-.322.322h-9.03a.3.3 0 1 0 0 .608h9.03a.932.932 0 0 0 .931-.93v-.721a.3.3 0 0 0-.309-.3z"
						transform="translate(-205.448 -303.397)"/>
					<Path
						d="M20.476 75.168a1.5 1.5 0 0 0-.8-.625l.1-.394a.887.887 0 0 0-.11-.705.975.975 0 0 0-.579-.424l-.263-.07a.937.937 0 0 0-1.159.637l-.857 3.224H.93a.931.931 0 0 0-.93.931v9.021a.931.931 0 0 0 .93.931h6.678a.3.3 0 0 0 0-.608H.93a.322.322 0 0 1-.322-.322v-9.023a.323.323 0 0 1 .322-.322h15.718l-.216.812-.624 2.345-.276 1.037a.925.925 0 0 0 .492 1.053l-.218.819a.3.3 0 1 0 .588.156l.214-.805a.991.991 0 0 0 .134.009.963.963 0 0 0 .455-.114.887.887 0 0 0 .446-.557l.276-1.038.419-1.576v5.1a.3.3 0 0 0 .608 0v-6.919a.925.925 0 0 0-.046-.289l.617-2.32a.89.89 0 0 1 .443.358.751.751 0 0 1 .1.6l-.5 1.884a.3.3 0 1 0 .588.156l.5-1.884a1.353 1.353 0 0 0-.168-1.074zm-3.421 6.857a.285.285 0 0 1-.145.177.369.369 0 0 1-.27.028l-.263-.07a.329.329 0 0 1-.258-.385l.2-.745.936.249zm.354-1.332l-.936-.249.468-1.761.936.249zm.625-2.349L17.1 78.1l1.157-4.352a.314.314 0 0 1 .314-.219c.033 0 .364.083.364.083a.369.369 0 0 1 .22.159.285.285 0 0 1 .038.226z"
					/>
				</G>
			</Svg>
		),


		'PaymentMean.transfert': color => (
			<Svg fill={color} viewBox="0 0 512 512">
				<Path
					d="m484.681 462.066h-5.88v-24.163c0-5.95-4.84-10.791-10.791-10.791h-17.608v-258.55h17.794c5.847 0 10.604-4.757 10.604-10.604v-28.726c0-5.847-4.758-10.604-10.604-10.604h-6.732v-16.723c0-9.178-7.466-16.644-16.643-16.644h-14.901v-44.761c0-8.719-7.094-15.813-15.813-15.813h-111.042l-33.398-20.809c-8.302-5.171-19.032-5.172-27.333.001l-33.397 20.807h-111.044c-8.719 0-15.813 7.094-15.813 15.813v44.762h-14.901c-9.177 0-16.643 7.466-16.643 16.644v16.723h-6.732c-5.847 0-10.604 4.758-10.604 10.604v28.726c0 5.847 4.757 10.604 10.604 10.604h17.794v258.55h-17.608c-5.95 0-10.791 4.84-10.791 10.791v24.163h-5.88c-5.95 0-10.791 4.84-10.791 10.791v28.353c0 5.95 4.84 10.791 10.791 10.791h113.892c4.137 0 7.49-3.353 7.49-7.49s-3.353-7.49-7.49-7.49h-109.702v-19.973h448.982v19.973h-304.538c-4.137 0-7.49 3.353-7.49 7.49s3.353 7.49 7.49 7.49h308.728c5.95 0 10.791-4.84 10.791-10.791v-28.353c-.001-5.951-4.841-10.791-10.791-10.791zm-70.574-422.399c.459 0 .833.374.833.833v44.762h-11.54c-2.033 0-4.019-.569-5.744-1.643h-.001l-70.545-43.952zm-317.046.833c0-.459.374-.833.833-.833h86.998l-70.547 43.952c-1.725 1.074-3.71 1.643-5.744 1.643h-11.54zm-31.544 61.405c0-.917.746-1.663 1.663-1.663h41.42c4.837 0 9.564-1.352 13.667-3.91l127.989-79.738c3.49-2.175 8.001-2.174 11.491-.001l127.989 79.739c4.104 2.558 8.83 3.91 13.667 3.91h41.42c.917 0 1.663.746 1.663 1.663v16.723h-380.969zm-17.337 51.677v-19.973h415.64v19.973zm387.242 14.981v258.55h-29.116v-258.55zm-102.419 102.762c-4.137 0-7.49 3.353-7.49 7.49v148.297h-29.116v-258.55h29.116v75.099c0 4.137 3.353 7.49 7.49 7.49s7.49-3.353 7.49-7.49v-75.099h50.831v258.55h-50.831v-148.297c0-4.137-3.353-7.49-7.49-7.49zm-51.587-102.762v258.55h-50.832v-258.55zm-65.812 0v258.55h-29.116v-258.55zm-44.097 0v258.55h-50.831v-258.55zm-65.812 0v258.55h-29.117v-258.55zm358.125 293.503h-415.64v-19.973h415.64z"/>
				<Path
					d="m255.337 41.414c-17.884 0-32.434 14.549-32.434 32.433s14.55 32.434 32.434 32.434 32.433-14.55 32.433-32.434-14.549-32.433-32.433-32.433zm0 49.887c-9.623 0-17.453-7.83-17.453-17.454 0-9.623 7.83-17.453 17.453-17.453s17.453 7.83 17.453 17.453c0 9.624-7.83 17.454-17.453 17.454z"/>
			</Svg>

		),

		'PaymentMean.offline': color => (
			<Svg viewBox="0 0 50 50.104" fill={color}>
				<Path
					d="M46.333 36.771H6.2l1.808-20.977a1.657 1.657 0 0 1 1.661-1.524h1.352v3.438H9.979a.833.833 0 1 0 0 1.667H25.4a.833.833 0 1 0 0-1.667h-1.046V4.167a.834.834 0 0 0-1.247-.724l-2.5 1.43-2.5-1.43a.834.834 0 0 0-.827 0l-2.5 1.43-2.5-1.43a.834.834 0 0 0-1.247.724V12.6H9.669a3.314 3.314 0 0 0-3.321 3.047L4.527 36.774A4.171 4.171 0 0 0 .5 40.937v5A4.171 4.171 0 0 0 4.667 50.1h41.666a4.171 4.171 0 0 0 4.167-4.163v-5a4.171 4.171 0 0 0-4.167-4.166zM12.687 5.6l1.67.954a.834.834 0 0 0 .827 0l2.5-1.43 2.5 1.43a.834.834 0 0 0 .827 0l1.67-.954v12.108h-10zm36.146 40.337a2.5 2.5 0 0 1-2.5 2.5H4.667a2.5 2.5 0 0 1-2.5-2.5v-5a2.5 2.5 0 0 1 2.5-2.5h41.666a2.5 2.5 0 0 1 2.5 2.5zm-22.5-32.5a.833.833 0 0 1 .833-.833h5.521v-1.042a.833.833 0 0 1 1.667 0V12.6h4.375v-1.038a.833.833 0 1 1 1.667 0V12.6h.935a3.314 3.314 0 0 1 3.321 3.047l1.485 17.224a.833.833 0 1 1-1.66.143l-1.485-17.22a1.657 1.657 0 0 0-1.661-1.524H27.167a.833.833 0 0 1-.834-.833zm5-3.854H41.75a3.337 3.337 0 0 0 3.333-3.333V3.333A3.337 3.337 0 0 0 41.75 0H31.333A3.337 3.337 0 0 0 28 3.333V6.25a3.337 3.337 0 0 0 3.333 3.333zm-1.667-6.25a1.669 1.669 0 0 1 1.667-1.667H41.75a1.669 1.669 0 0 1 1.667 1.667V6.25a1.669 1.669 0 0 1-1.667 1.667H31.333a1.669 1.669 0 0 1-1.666-1.667zm-16.146 20.1a2.5 2.5 0 0 0-2.5 2.5v3.75a2.5 2.5 0 0 0 2.5 2.5h8.333a2.5 2.5 0 0 0 2.5-2.5v-3.75a2.5 2.5 0 0 0-2.5-2.5zm9.167 2.5v3.75a.834.834 0 0 1-.833.833h-8.333a.834.834 0 0 1-.833-.833v-3.75a.834.834 0 0 1 .833-.833h8.333a.834.834 0 0 1 .833.837zM30.5 23.75a.833.833 0 0 1-.833.833h-.937a.833.833 0 1 1 0-1.667h.938a.833.833 0 0 1 .832.834zm5.208 0a.833.833 0 0 1-.833.833h-.937a.833.833 0 0 1 0-1.667h.937a.833.833 0 0 1 .833.834zm5.208 0a.833.833 0 0 1-.833.833h-.937a.833.833 0 0 1 0-1.667h.937a.833.833 0 0 1 .834.834zM30.5 30a.833.833 0 0 1-.833.833h-.937a.833.833 0 1 1 0-1.667h.938A.833.833 0 0 1 30.5 30zm5.208 0a.833.833 0 0 1-.833.833h-.937a.833.833 0 0 1 0-1.667h.937a.833.833 0 0 1 .833.834zm5.208 0a.833.833 0 0 1-.833.833h-.937a.833.833 0 0 1 0-1.667h.937a.833.833 0 0 1 .834.834z"
					transform="translate(-.5)"/>
			</Svg>
		),

	},

	...{ // reservations
		'reservation-restaurant': color => (
			<Svg viewBox="0 0 14 13">
				<Path
					d="M3.74332 6.94699L5.73332 5.00599L0.812325 0.247986C0.555567 0.497815 0.351483 0.79657 0.212128 1.1266C0.0727744 1.45663 0.000976562 1.81124 0.000976562 2.16949C0.000976562 2.52773 0.0727744 2.88234 0.212128 3.21237C0.351483 3.5424 0.555567 3.84116 0.812325 4.09099L3.74332 6.94699Z"
					fill={color}/>
				<Path
					d="M8.4929 5.723C9.12971 5.94238 9.81707 5.96907 10.469 5.79974C11.1209 5.6304 11.7084 5.27256 12.1579 4.771C13.4839 3.479 13.7639 1.608 12.7169 0.621999C11.7049 -0.398001 9.7849 -0.126001 8.4589 1.166C7.95161 1.59078 7.58619 2.16041 7.41159 2.79861C7.23698 3.43681 7.26151 4.11313 7.4819 4.737C5.21761 6.96417 2.94727 9.18518 0.670898 11.4L1.6479 12.352L6.4639 7.659L11.2799 12.352L12.2569 11.4L7.4409 6.707L8.4929 5.723Z"
					fill={color}/>
			</Svg>
		),
		'reservation-place': color => (
			<Svg viewBox="0 0 20 14.286">
				<Path d="M9.031 10.771c2.047-.473 3.242-.886 2.319-2.63C8.541 2.836 10.606 0 13.572 0c3.025 0 5.039 2.946 2.221 8.141-.951 1.754.312 2.167 2.316 2.63 1.774.41 1.891 1.276 1.891 2.778v.736H7.143c0-1.96-.157-3.041 1.888-3.514zM0 14.286h5.578c-.025-5.841 2.454-3.8 2.454-7.948a2.554 2.554 0 0 0-2.677-2.767c-2.225 0-3.773 2.129-1.666 6.107.692 1.307-.737 1.622-2.273 1.972C.086 11.957 0 12.607 0 13.734v.552z"
					  fill={color}/>
			</Svg>
		),
		'reservation-calendar': color => (
			<Svg viewBox="0 0 17 17">
				<Path d="M14.167 14.167h-2.834v-2.834h2.833zm-4.25-7.084H7.083v2.834h2.834zm4.25 0h-2.834v2.834h2.833zm-8.5 4.25H2.833v2.833h2.834zm4.25 0H7.083v2.833h2.834zm-4.25-4.25H2.833v2.834h2.834zM17 1.417V17H0V1.417h2.125v.708a1.417 1.417 0 0 0 2.833 0v-.708h7.083v.708a1.417 1.417 0 0 0 2.833 0v-.708zm-1.417 4.25H1.417v9.917h14.166zM14.167.708a.708.708 0 1 0-1.417 0v1.417a.708.708 0 1 0 1.417 0zM4.25 2.125a.708.708 0 0 1-1.417 0V.708a.708.708 0 0 1 1.417 0z"
					  fill={color}/>
			</Svg>
		),
		'reservation-clock': color => (
			<Svg viewBox="0 0 13.01 17.346">
				<Path d="m9.143 9.1 2.53.686v.332H8.059V5.782h.369zm6.867-1.15h-.773a5.977 5.977 0 0 0-1.913-3.681C12.4 3.427 12.436 2.645 11.982 0H6.305c-.454 2.645-.414 3.427-1.341 4.269a5.97 5.97 0 0 0 0 8.854c.925.841.89 1.639 1.339 4.223h5.677c.45-2.585.414-3.382 1.34-4.223A5.978 5.978 0 0 0 15.244 9.4h.765V7.95zm-6.867 5.421a4.7 4.7 0 1 1 4.7-4.7 4.7 4.7 0 0 1-4.7 4.7z" transform="translate(-3)"
				fill={color}/>
			</Svg>
		),

		'reservation-phone': color => (
			<Svg xmlns="http://www.w3.org/2000/svg" width="14.75" height="19.668" viewBox="0 0 14.75 19.668">
				<Path d="m12.685 18.788-.978.539C5.988 22.294-3.93 4.991 1.645 1.721l.938-.521 3.044 5.3-.933.518c-1.694 1.02 2.262 7.955 4 7l.952-.526 3.041 5.295zM4.647 0 3.271.8l3.043 5.3 1.378-.8zm7.058 12.29-1.377.8 3.044 5.3 1.378-.8-3.044-5.3z"
				fill={color}/>
			</Svg>
		),
	}
})
